/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Tag } from 'antd';

// Misc imports
import { ACTIVITY_TYPES } from '../../constants/main';

const ActivityTypeTag = (props) => {
  const { type, customTag, ...restProps } = props;
  const { t } = useTranslation();

  const getTagColor = () => {
    switch (type) {
      case ACTIVITY_TYPES.DECISION_TREE:
        return 'geekblue';

      case ACTIVITY_TYPES.LIVECHAT_FLOW:
        return 'cyan';

      case ACTIVITY_TYPES.INTERVIEW:
      case ACTIVITY_TYPES.AUTOMATED_ANSWERS:
        return 'blue';

      case ACTIVITY_TYPES.USER_FEEDBACK:
      case ACTIVITY_TYPES.LIVECHAT_SYSTEM_MESSAGE:
        return 'purple';

      case ACTIVITY_TYPES.KNOWLEDGE_BASE_ARTICLE:
        return 'green';

      default:
        return null;
    }
  };

  return getTagColor() ? (
    <Tag className={customTag && `border-0 bg-none fs-base`} color={getTagColor()} {...restProps}>
      { customTag ? customTag : t(type, { context: 'activity type' })}
    </Tag>
  ) : null;
};

ActivityTypeTag.propTypes = {
  type: PropTypes.string,
  customTag: PropTypes.any
};

export default ActivityTypeTag;
